import { TSupplementResponseStatus } from '@interfaces/supplements';

import useSupplementResponseStatuses from './useSupplementResponseStatuses';

const useSupplementResponseStatusById = (statusId?: TSupplementResponseStatus) => {
  const supplementResponseStatuses = useSupplementResponseStatuses();
  return supplementResponseStatuses.find(status => status.id === statusId);
};

export default useSupplementResponseStatusById;
